import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  CircularProgress,
  Box,
} from '@mui/material';
import { LoadingDialogConfig } from '../../stores/dialogStore';

interface LoadingDialogProps {
  config: LoadingDialogConfig;
}

function LoadingDialog({ config }: LoadingDialogProps) {
  return (
    <Dialog
      open={config.open}
      maxWidth={config.maxWidth || 'sm'}
      fullWidth={config.fullWidth !== false}
      aria-labelledby="loading-dialog-title"
    >
      <DialogTitle id="loading-dialog-title">
        <Typography variant="h4">{config.title}</Typography>
      </DialogTitle>

      <DialogContent>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            py: 3,
          }}
        >
          <CircularProgress sx={{ mb: 2 }} />
          <Typography variant="body1" color="textSecondary">
            {config.message}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default LoadingDialog;
